module.exports = __webpack_public_path__ + "media/images/noticias/placeholdercuatro-222918744eda790dd46ec08e2a138f46.jpg";